import { VehicleIdentified } from 'src/types/vehicle.type';

export const convertVehicleRecordToEditFormData = (vehicle: VehicleIdentified) => {
  return {
    id: vehicle.id,
    brandId: vehicle.brandId,
    name: vehicle.name,
    vehicleTypeId: vehicle.vehicleTypeId,
    colorId: vehicle.colorId,
    plate: vehicle.plate,
    staff: vehicle?.staff ?? undefined,
    organization: vehicle?.organization ?? undefined,
    description: vehicle?.description ?? undefined,
  };
};
